import { ConfigProvider } from '@portals/sip-client-data/src/general/Config';

import { Storage } from '../utils';

export const STORAGE_KEY_BOOKMARKS = 'bookmarks';
const STORAGE_KEY_BOOKMARKS_SIP = `${STORAGE_KEY_BOOKMARKS}_sip`;
const STORAGE_KEY_BOOKMARKS_IMMOBILIEN = `${STORAGE_KEY_BOOKMARKS}_immobilien`;

export interface BookmarkType {
  estateId: string;
}

export const getBookmarksStorageKey = (customUseImmobilienApi?: boolean): string => {
  if (customUseImmobilienApi !== undefined) {
    return customUseImmobilienApi ? STORAGE_KEY_BOOKMARKS_IMMOBILIEN : STORAGE_KEY_BOOKMARKS_SIP;
  }
  // TODO: REMOVE AFTER IMMOBILIEN API INTEGRATION: switch
  const useImmobilienApi = ConfigProvider.getConfig().get('USE_IMMOBILIEN_API') === 'true';
  return useImmobilienApi ? STORAGE_KEY_BOOKMARKS_IMMOBILIEN : STORAGE_KEY_BOOKMARKS_SIP;
};

export const addBookmark = (estateId: string): boolean => {
  const bookmarks = getBookmarks();

  if (!bookmarkExists(estateId)) {
    bookmarks.push({ estateId });

    return saveBookmarks(bookmarks);
  }

  return false;
};

export const removeBookmark = (estateId: string): boolean => {
  const bookmarks = getBookmarks();
  const bookmarkPosition = bookmarks.findIndex((bookmark) => bookmark.estateId === estateId);

  if (bookmarkExists(estateId)) {
    bookmarks.splice(bookmarkPosition, 1);

    return saveBookmarks(bookmarks);
  }

  return false;
};

export const bookmarkExists = (estateId: string): boolean => {
  return getBookmarks().some((bookmark) => bookmark.estateId === estateId);
};

export const getBookmarks = (): BookmarkType[] => {
  const bookmarks = Storage.get(getBookmarksStorageKey());

  return bookmarks || [];
};

const saveBookmarks = (bookmarks: BookmarkType[]): boolean => {
  try {
    Storage.set(getBookmarksStorageKey(), bookmarks);
  } catch (e) {
    return false;
  }

  return true;
};

export const isLocalStorageBookmarksEnabled = (): boolean =>
  ConfigProvider.getConfig().get('LOCALSTORAGE_BOOKMARKS') === '1';

export const getBookmarkIds = (bookmarks: BookmarkType[]): string[] => {
  return bookmarks.map((bookmark) => bookmark.estateId);
};
